import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import {
  FormikLabeledField,
  FormikTextInput,
  FormikSelect
} from "../../components/form.js";
import {
  newIsFieldRequired,
  newGetFieldLabel,
  newGetFieldPlaceholder,
  newGetSelectFieldOptions,
  useAmsSelector
} from "@awe-web/shared/lib";

import "./select_driver_form.scss";

export default function SelectDriverForm({ className }) {
  const isFieldRequired = useAmsSelector((state) => newIsFieldRequired("personContractDriver")(state));
  const getFieldLabel = useAmsSelector((state) => newGetFieldLabel("personContractDriver")(state));
  const getFieldPlaceholder = useAmsSelector((state) => newGetFieldPlaceholder("personContractDriver")(state));
  const getSelectFieldOptions = useAmsSelector((state) => newGetSelectFieldOptions("personContractDriver")(state));

  const combinedClassName = classnames("select-driver-form", className);

  return (
    <div className={combinedClassName}>
      <FormikLabeledField
        name="Person:prefixKey"
        as={FormikSelect}
        isFieldRequired={isFieldRequired}
        getFieldLabel={getFieldLabel}
        options={getSelectFieldOptions("Person:prefixKey")}
      />

      <FormikLabeledField
        name="Person:name"
        as={FormikTextInput}
        isFieldRequired={isFieldRequired}
        getFieldLabel={getFieldLabel}
        placeholder={getFieldPlaceholder("Person:name")}
      />

      <FormikLabeledField
        name="Person:surname"
        as={FormikTextInput}
        isFieldRequired={isFieldRequired}
        getFieldLabel={getFieldLabel}
        placeholder={getFieldPlaceholder("Person:surname")}
      />

      <FormikLabeledField
        name="Address:email"
        as={FormikTextInput}
        isFieldRequired={isFieldRequired}
        getFieldLabel={getFieldLabel}
        placeholder={getFieldPlaceholder("Address:email")}
        email={true}
      />

      <FormikLabeledField
        name="Address:phone"
        as={FormikTextInput}
        isFieldRequired={isFieldRequired}
        getFieldLabel={getFieldLabel}
        placeholder={getFieldPlaceholder("Address:phone")}
      />

      <FormikLabeledField
        name="employeeId"
        as={FormikTextInput}
        isFieldRequired={isFieldRequired}
        getFieldLabel={getFieldLabel}
        placeholder={getFieldPlaceholder("employeeId")}
      />

      <FormikLabeledField
        name="costCenter"
        as={FormikTextInput}
        isFieldRequired={isFieldRequired}
        getFieldLabel={getFieldLabel}
        placeholder={getFieldPlaceholder("costCenter")}
      />
    </div>
  );
}

SelectDriverForm.propTypes = {
  className: PropTypes.string
};
